import React from 'react';
import UploadingPopupAnimation from "../../UploadingPopupAnimation";
import CsvUploadLoaderBackground from "../../../assets/images/loading-data-placeholder.png";
import {useTranslation} from "react-i18next";

const ValidateCsv = ({setUploadedTemplate, setActiveStep}) => {

    const { t } = useTranslation();
    const handlePopupAnimationClose = () => {
        setUploadedTemplate(null);
        setActiveStep(2);
    }

    return (
        <div className="step">
            <div className="validate-csv">
                <h4>{t("CSV Field Details Uploading...")}</h4>
                <UploadingPopupAnimation title={t("CSV Uploading...")} description={t("Please wait...")}
                                         onClose={handlePopupAnimationClose}/>
                <img src={CsvUploadLoaderBackground} alt="CSV Upload Loader Background"
                     className="csv-upload-loader-background"/>
            </div>
        </div>
    );
};

export default ValidateCsv;
